import request from '@/utils/request'

// 仓库列表
export function warehouse_list (query) {
  return request({
    url: '/wms/warehouse/',
    method: 'get',
    params: query
  })
}
